import React, {useState} from "react"
import Feature from "./Feature"

function FeatureOverview() {

    const [features] = useState([
      { iconpath: "./assets/img/icons/duotone-icons/Files/File.svg", title: "Extract Data", description: "We extract structured data from sites fully automated, stable and resilient"},
      { iconpath: "./assets/img/icons/duotone-icons/Home/Bulb_1.svg", title: "Analyze Data", description: "We gather insights from collected and internal data silos and connect them"},
      { iconpath: "./assets/img/icons/duotone-icons/Devices/Server.svg", title: "Automate Tasks", description: "We automate form filling, login, search, purchases and other processes"}
    ])

    return (
      <div>
      <section className="py-8 py-md-11 border-bottom">
      <div className="container">
        <div className="row">
          {features.map((feature, index) => (
            <div 
              className="col-12 col-md-4" 
              data-aos="fade-up"
              data-aos-delay={index * 50}>
              <Feature iconpath={feature.iconpath} title={feature.title} description={feature.description}/>
            </div>
          ))}
        </div>
      </div>
    </section>
    <br/>
    </div>
    )
}

export default FeatureOverview
